import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { authMe, authLogout } from "../services/member/kakaoApi";

export const initState = {
  userPk: null,
  email: "",
  nickname: "",
  joinSeason: 0,
  additionalInfoUpdated: false,
  kakaoTalkActivityStatus: null,
  dormant: false,
  userType: "",
  checked: false,
};

export const fetchMeAsync = createAsyncThunk(
  "login/fetchMe",
  async (_, { rejectWithValue }) => {
    try {
      const res = await authMe();
      return res.data;
    } catch (e) {
      return rejectWithValue(e?.response?.data || null);
    }
  }
);

export const logoutAsync = createAsyncThunk(
  "login/logout",
  async (_, { rejectWithValue }) => {
    try {
      await authLogout();
      return true;
    } catch (e) {
      return rejectWithValue(e?.response?.data || null);
    }
  }
);

const loginSlice = createSlice({
  name: "loginSlice",
  initialState: initState,
  reducers: {
    setMember: (state, action) => {
      const p = action.payload || {};
      state.userPk = p.userPk ?? null;
      state.email = p.email ?? "";
      state.nickname = p.nickname ?? "";
      state.joinSeason = p.joinSeason ?? 0;
      state.additionalInfoUpdated = p.additionalInfoUpdated ?? false;
      state.kakaoTalkActivityStatus = p.kakaoTalkActivityStatus ?? null;
      state.dormant = p.dormant ?? false;
      state.userType = p.userType ?? "";
      state.checked = true;
    },
    clearMember: (state) => {
      state.userPk = null;
      state.email = "";
      state.nickname = "";
      state.joinSeason = 0;
      state.additionalInfoUpdated = false;
      state.kakaoTalkActivityStatus = null;
      state.dormant = false;
      state.userType = "";
      state.checked = true;
    },
    markChecked: (state) => {
      state.checked = true;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchMeAsync.fulfilled, (state, { payload }) => {
        const p = payload || {};
        state.userPk = p.userPk ?? null;
        state.email = p.email ?? "";
        state.nickname = p.nickname ?? "";
        state.joinSeason = p.joinSeason ?? 0;
        state.additionalInfoUpdated = p.additionalInfoUpdated ?? false;
        state.kakaoTalkActivityStatus = p.kakaoTalkActivityStatus ?? null;
        state.dormant = p.dormant ?? false;
        state.userType = p.userType ?? "";
        state.checked = true;
      })
      .addCase(fetchMeAsync.rejected, (state) => {
        state.userPk = null;
        state.email = "";
        state.nickname = "";
        state.joinSeason = 0;
        state.additionalInfoUpdated = false;
        state.kakaoTalkActivityStatus = null;
        state.dormant = false;
        state.userType = "";
        state.checked = true;
      })
      .addCase(logoutAsync.fulfilled, (state) => {
        state.userPk = null;
        state.email = "";
        state.nickname = "";
        state.joinSeason = 0;
        state.additionalInfoUpdated = false;
        state.kakaoTalkActivityStatus = null;
        state.dormant = false;
        state.userType = "";
        state.checked = true;
      });
  },
});

export const { setMember, clearMember, markChecked } = loginSlice.actions;
export default loginSlice.reducer;
